import { FaFilePdf } from "react-icons/fa";
import styled from "styled-components";
export default function PDFButton({ onClick }) {
  return (
    <Button onClick={onClick}>
      <FaFilePdf size={18} />
    </Button>
  );
}

const Button = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.55rem 0.9rem;
  border-radius: 20%;
  border: none;
  background-color: #40e5a0;
  box-shadow: 0px 0px 3px 0px #000000;
  &:hover {
    filter: brightness(0.9);
  }
`;
